import { useQuery } from '@tanstack/react-query';
import api from 'api';
import { getMixpanelErrorProps } from 'axiosUtils';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import useInvalidateQueryOnUnmount from 'hooks/useInvalidateQueryOnUnmount';
import { ErrorViewedProps } from 'models/MixpanelEvents';
import { GeneralSuggestedAction } from 'models/SuggestedActions';
import mixpanelService from 'services/mixpanelService';

export const GENERAL_SUGGESTED_ACTIONS_QUERY_KEY = 'general-suggested-actions';

export default function useGeneralSuggestedActionsQuery() {
  const getMixpanelProps = useGetMixpanelProps();

  const query = useQuery<GeneralSuggestedAction[]>({
    queryKey: [GENERAL_SUGGESTED_ACTIONS_QUERY_KEY],
    queryFn: async () => {
      const { data } =
        await api.userSuggestedActions.getGeneralSuggestedActions();

      return data;
    },
    onError: (error) =>
      mixpanelService.errorViewed(
        getMixpanelProps(getMixpanelErrorProps(error)) as ErrorViewedProps,
      ),
  });

  useInvalidateQueryOnUnmount(GENERAL_SUGGESTED_ACTIONS_QUERY_KEY);

  return query;
}
